import React, {InputHTMLAttributes, ReactNode} from 'react';

import {Label} from '../Label';

import {Adornment, InputContainer, NativeInput} from './styled';

// @ts-ignore
export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    className?: string;
    label?: string;
    hasError?: boolean;
    placeholder?: string;
    adornment?: ReactNode;
    disableAdornmentPointerEvents?: boolean;
    formFieldName?: string;
    isRequired?: boolean;
    size?: 'sm' | 'md';
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    (
        {
            className,
            label,
            hasError = false,
            adornment,
            disableAdornmentPointerEvents,
            value,
            isRequired = false,
            disabled = false,
            size = 'md',
            ...otherProps
        },
        ref,
    ) => {
        const hasAdornment = Boolean(adornment);
        const innerValue = React.useMemo(() => value ?? '', [value]);
        return (
            <InputContainer className={className}>
                <Label text={label} hasError={hasError} isRequired={isRequired}>
                    <NativeInput
                        ref={ref}
                        hasError={hasError}
                        hasAdornment={hasAdornment}
                        value={innerValue}
                        className="wwm__native-input"
                        disabled={disabled}
                        size={size as any}
                        {...otherProps}
                    />
                    {hasAdornment && (
                        <Adornment disablePointerEvents={disableAdornmentPointerEvents}>
                            {adornment}
                        </Adornment>
                    )}
                </Label>
            </InputContainer>
        );
    },
);
